import { initCA as I } from "./contact-channels51.js";
import { useMemo as y, useCallback as h, useEffect as S } from "react";
import { useQuery as L } from "./contact-channels42.js";
import { useQueryClient as O } from "./contact-channels52.js";
import { useContactChannelsContext as _ } from "./contact-channels19.js";
import { getChatInfo as M } from "./contact-channels53.js";
import { attempt as Q } from "./contact-channels54.js";
import { useEmergencyCheck as B } from "./contact-channels2.js";
import { useTranslations as T } from "./contact-channels43.js";
import { NRLogger as E } from "./contact-channels45.js";
const G = (C = !0) => {
  const { locale: r, tenant: l, isProadvantage: f } = _(), { t: n } = T(), c = O(), { data: t, isLoading: A } = B(C), s = y(
    () => ["chat-status", l, r, f, t == null ? void 0 : t.enabled],
    [t, f, r, l]
  ), g = h(async () => {
    var b, m, D;
    const a = f ? "ProAdvantageChat" : "ContactUsPage";
    if (t != null && t.enabled || (b = t == null ? void 0 : t.config) != null && b.chatDisabled)
      return E.warn("Contact Channels: useChat", {
        emergencyEnabled: (t == null ? void 0 : t.enabled) || !1,
        chatDisabled: ((m = t == null ? void 0 : t.config) == null ? void 0 : m.chatDisabled) || !1,
        message: "Chat service is disabled due to emergency",
        locale: r,
        tenant: l,
        isProadvantage: f,
        reason: "EMERGENCY"
      }), {
        isAvailable: !1,
        availabilityInfo: {
          reason: "EMERGENCY",
          emergencyMessage: (t == null ? void 0 : t.message) ?? ""
        },
        plainData: {
          chatStatus: "offline",
          gcpChatStatus: !1
        },
        ui: {
          title: n("chat.title"),
          description: n("chat.buttons.chat_unavailable.description")
        }
      };
    I();
    const { data: e, error: o } = await Q(M(l, r, a));
    if (o)
      return E.error("Contact Channels: useChat", {
        reason: "DISABLED",
        ...o,
        tenant: l,
        locale: r,
        chatType: a
      }), {
        isAvailable: !1,
        availabilityInfo: {
          reason: "DISABLED"
        },
        plainData: {
          chatStatus: "offline",
          gcpChatStatus: !1
        },
        ui: {
          title: n("chat.title"),
          description: n("chat.buttons.chat_offline.description")
        }
      };
    const i = ((D = e == null ? void 0 : e.status) == null ? void 0 : D.isChatEnabled) ?? !1;
    return {
      isAvailable: i,
      availabilityInfo: i ? void 0 : {
        reason: "DISABLED"
      },
      plainData: {
        chatStatus: i ? "preparing" : "offline",
        gcpChatStatus: i
      },
      ui: {
        title: n("chat.title"),
        description: n(i ? "chat.standard.description" : "chat.buttons.chat_offline.description")
      }
    };
  }, [f, r, l, t, n]), v = L({
    queryKey: s,
    queryFn: g,
    enabled: !A && C,
    staleTime: 1 / 0,
    gcTime: 1 / 0,
    refetchOnWindowFocus: !1
  }), u = h(() => {
    c.setQueryData(s, (a) => a && {
      ...a,
      plainData: {
        ...a.plainData,
        chatStatus: "chatting"
      }
    });
  }, [c, s]), d = h(() => {
    c.setQueryData(s, (a) => {
      var i;
      if (!a) return a;
      const e = ((i = a.plainData) == null ? void 0 : i.gcpChatStatus) ?? !1;
      return {
        isAvailable: e,
        availabilityInfo: e ? void 0 : {
          reason: "OUT_OF_BUISNESS_HOURS"
        },
        plainData: {
          chatStatus: e ? "online" : "offline",
          gcpChatStatus: e
        },
        ui: {
          title: n("chat.title"),
          description: n(e ? "chat.standard.description" : "chat.buttons.chat_offline.description")
        }
      };
    });
  }, [c, s, n]), p = h(() => {
    c.setQueryData(s, (a) => a && {
      ...a,
      isAvailable: !1,
      availabilityInfo: {
        reason: "DISABLED"
      },
      plainData: {
        ...a.plainData,
        chatStatus: "offline"
      }
    });
  }, [c, s]);
  return S(() => {
    document.dispatchEvent(new CustomEvent("helpCenterCAEvent"));
    const a = {
      CAonChatInit: d,
      CAonSessionActive: u,
      CAafterMaximize: u,
      CAafterDestroy: d,
      CAchatOffline: p
    };
    return Object.entries(a).forEach(([e, o]) => {
      document.addEventListener(e, o);
    }), () => {
      Object.entries(a).forEach(([e, o]) => {
        document.removeEventListener(e, o);
      });
    };
  }, [d, u, p]), v;
};
export {
  G as useChat
};
//# sourceMappingURL=contact-channels5.js.map
